<template>
  <div class="bz-rail">
    <div class="bz-rail-h">Your profile</div>
    <div class="bz-rail-list">
      <button v-for="item in items" :key="item.label" type="button"
        class="bz-rail-row" :class="{ filled: !!item.value }" @click="$emit('jump', item.step)">
        <span class="bz-rail-k">{{ item.label }}</span>
        <span class="bz-rail-v">{{ item.value || 'Not selected' }}</span>
        <i class="material-icons" style="font-size:14px;line-height:1;color:var(--bzc-faint);">edit</i>
      </button>
    </div>
    <div v-if="upsellAccepted" class="bz-upsell added">
      <i class="material-icons" style="font-size:17px;line-height:1;color:var(--bzc-good);">check_circle</i>
      <div class="bz-upsell-body">
        <b>{{ product === 'IMP' ? 'Industry Financial Profile' : 'Industry Market Profile' }} added</b>
        <span>It will be added to your cart with this profile — same industry &amp; area{{ upsellBandLabel ? ', ' + upsellBandLabel : '' }}.</span>
      </div>
    </div>
    <label v-if="legacyAvailable" class="bz-legacy">
      <input type="checkbox" :checked="legacyChecked" @change="$emit('legacy-toggle', $event.target.checked)" />
      <span>{{ legacyLabel }}</span>
    </label>
    <div class="bz-rail-foot">
      <div class="bz-status" :class="status.state === 'ok' ? 'ok' : 'todo'">
        <i class="material-icons" style="font-size:16px;line-height:1;">{{ status.state === 'ok' ? 'check_circle' : 'info' }}</i>
        <span v-if="status.state === 'ok'"><b>Available now</b> · data through {{ dataYear }}</span>
        <span v-else>{{ status.msg }}</span>
      </div>
      <div class="bz-cta-wrap">
        <button class="bz-btn primary" type="button" :disabled="status.state !== 'ok' || ctaDone || submitting" @click="$emit('access')">
          <template v-if="ctaDone">
            <i class="material-icons" style="font-size:16px;line-height:1;">check</i>Added — opening profile…
          </template>
          <template v-else-if="submitting">Processing…</template>
          <template v-else>
            Access Now<i class="material-icons" style="font-size:16px;line-height:1;">arrow_forward</i>
          </template>
        </button>
        <span v-if="ctaDone && upsellAccepted" class="bz-cta-note">2 products added to cart together.</span>
        <span v-else-if="ctaDone" class="bz-cta-note">No waiting — availability was verified as you selected.</span>
      </div>
    </div>
  </div>
</template>

<script>
import { SALES_BY_ID } from './model';

export default {
  name: 'summary-rail',
  props: {
    product: { type: String, required: true },
    selection: { type: Object, required: true }, // {industry, area, sc, structure, timeline}
    status: { type: Object, required: true }, // {state:'todo'|'ok', msg?}
    ctaDone: { type: Boolean, default: false },
    submitting: { type: Boolean, default: false },
    upsellAccepted: { type: Boolean, default: false },
    upsellBand: { type: String, default: null },
    // legacy (archive-year) add-on — IFP + All-US only, see SelectorPage.probeLegacy
    legacyAvailable: { type: Boolean, default: false },
    legacyLabel: { type: String, default: '' },
    legacyChecked: { type: Boolean, default: false },
  },
  computed: {
    dataYear() {
      return new Date().getFullYear() - 1;
    },
    upsellBandLabel() {
      return this.upsellBand && SALES_BY_ID[this.upsellBand] ? SALES_BY_ID[this.upsellBand].label : null;
    },
    items() {
      const s = this.selection;
      const rows = [
        { label: 'Industry', value: s.industry ? s.industry.name + ' [' + s.industry.code + ']' : null, step: 1 },
        { label: 'Market Area', value: s.area ? s.area.label : null, step: 2 },
      ];
      if (this.product === 'IFP') {
        rows.push({ label: 'Sales Class', value: s.sc && SALES_BY_ID[s.sc] ? SALES_BY_ID[s.sc].label : null, step: 3 });
        rows.push({ label: 'Structure', value: s.structure === 'sole_proprietorship' ? 'Sole Proprietorship' : 'Industry Firms', step: 4 });
        rows.push({ label: 'Time Series', value: s.timeline === '3yr' ? '3 Years Profile' : '5 Years Profile', step: 4 });
      }
      return rows;
    },
  },
};
</script>
